/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Availability } from './';
import {
    AvailabilityFromJSON,
    AvailabilityFromJSONTyped,
    AvailabilityToJSON,
} from './';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';
import type { WorkConditions } from './';
import {
    WorkConditionsFromJSON,
    WorkConditionsFromJSONTyped,
    WorkConditionsToJSON,
} from './';
import type { WorkingStatus } from './';
import {
    WorkingStatusFromJSON,
    WorkingStatusFromJSONTyped,
    WorkingStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface Hybrid
 */
export interface Hybrid extends WorkConditions {
    /**
     * 
     * @type {PostalAddress}
     * @memberof Hybrid
     */
    address: PostalAddress;
    /**
     * 
     * @type {number}
     * @memberof Hybrid
     */
    frequency: number;
}

/**
 * Check if a given object implements the Hybrid interface.
 */
export function instanceOfHybrid(value: object): value is Hybrid {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    return true;
}

export function HybridFromJSON(json: any): Hybrid {
    return HybridFromJSONTyped(json, false);
}

export function HybridFromJSONTyped(json: any, ignoreDiscriminator: boolean): Hybrid {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...WorkConditionsFromJSONTyped(json, ignoreDiscriminator),
        'address': PostalAddressFromJSON(json['address']),
        'frequency': json['frequency'],
    };
}

export function HybridToJSON(value?: Hybrid | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...WorkConditionsToJSON(value, true),
        'address': PostalAddressToJSON(value['address']),
        'frequency': value['frequency'],
    };
}

